// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__LfKFT","active":"Alert_active__cZ-QI","btnClose":"Alert_btnClose__HU9EO"};